import { useId } from 'react';
import { Svg } from './styles';

interface CelsiusAiMarkProps {
  size?: number | string;
  white?: boolean;
  spin?: boolean;
}

const PATH = 'M 50 5 C 50 43.25, 55.85 46.62, 88.97 27.5 C 55.85 46.62, 55.85 53.38, 88.97 72.5 C 55.85 53.38, 50 56.75, 50 95 C 50 56.75, 44.15 53.38, 11.03 72.5 C 44.15 53.38, 44.15 46.62, 11.03 27.5 C 44.15 46.62, 50 43.25, 50 5 Z';

export const CelsiusAiMark = ({
  size = 24,
  white = false,
  spin = false,
}: CelsiusAiMarkProps): JSX.Element => {
  const uid = useId().replace(/:/g, '');
  const gradId = `cai-grad-${uid}`;

  if (white) {
    return (
      <Svg width={size} height={size} viewBox="0 0 100 100" fill="none" $spin={spin}>
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"
          d={PATH}
        />
      </Svg>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 100 100" fill="none" $spin={spin}>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#1890FF" />
          <stop offset="1" stopColor="#00FF9B" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradId})`}
        stroke={`url(#${gradId})`}
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
        d={PATH}
      />
    </Svg>
  );
};
